import { Title } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { EventListener } from "react-lottie";

import { LSuccessIcon } from "@/assets/lottie";

export function CheckInCompleted() {
  const navigate = useNavigate();

  const successListener: EventListener[] = [
    {
      eventName: "complete",
      callback: () => {
        navigate({ to: "/app" });
      }
    }
  ];

  return (
    <>
      <Title order={1}>Check-In realizado com Sucesso!</Title>

      <LSuccessIcon options={{ loop: 1 }} eventListeners={successListener} />
    </>
  );
}
